import MiniCapture from "../common/MiniCapture";

const PhyMeasurementsSection = (props) => {
  const {
    isApprover,
    isRequestForChange,
    isAppprovalPending,
    handleApproverComments,
    handleApproverCheckbox,
    approverComments,
    approverCheckbox,
    mandatoryFieldRef,
    formData,
    handleDeleteImages,
    resetCaptureFlag,
    handleFormDataChange,
    isView,
    handleGapsChange,
    actionmenuFlag,
    actionImages,
    handleImagesChangeMini,
    handleResetAction,
    handleActionFieldsChange,
    isDoubleDoor
  } = props;

  // The field refs are used to validate required physical measurement inputs during approval workflows.
  // Approver-only comment inputs are rendered conditionally based on request-for-change state.



  return (
    <div className="card-body">
      <div className="col-sm-12">
        <p className="fs-6 fw-semibold">Physical Measurements - Gaps</p>
      </div>
      {!isDoubleDoor && isRequestForChange && isApprover && (
        <div className="form-floating d-flex justify-content-end pb-2">
          <input
            className="form-check-input form-check-input-checkbox custom-checkbox"
            type="checkbox"
            id="headCheckbox"
            disabled={!isAppprovalPending}
            name="head"
            checked={approverCheckbox?.head || false}
            onChange={(e) => handleApproverCheckbox(e)}
          />
        </div>
      )}
      {!isDoubleDoor && <div className="form-floating mb-3">
        {/* Single-door head gap measurement field */}
        <input
          type="number"
          pattern="[0-9]*"
          inputMode="decimal"
          onKeyDown={(e) => {
            if (e.key === "-" || e.key === "e") {
              e.preventDefault(); // Prevent invalid characters
            }
          }}
          disabled={isApprover ? isView : (isView && !approverCheckbox.head)}
          className="form-control"
          id="floatingInputValue"
          placeholder="Head(mm) "
          name="head"
          ref={(el) => (mandatoryFieldRef.current.head = el)}
          value={formData.head}
          onChange={handleGapsChange}
          min={0}
        />
        <label htmlFor="floatingInputValue">
          Head(mm)<span style={{ color: "red" }}>*</span>
        </label>
        {actionmenuFlag.head && (
          <div className="col-sm-12 mb-3 border p-2 rounded">
            {/* Capture images for head measurement action items */}
            <MiniCapture
              isView={isApprover ? isView : (isView && !approverCheckbox.head)}
              fieldValue={"head"}
              savedImages={actionImages.head}
              formData={formData}
              onImagesChange={(images, nameOfFile) =>
                handleImagesChangeMini(images, "head", nameOfFile)
              }
              onResetChange={() => handleResetAction("head", "PHYSICAL")}
              onHandleActionFieldsChange={(e, field) => {
                handleActionFieldsChange(e, field, "PHYSICAL");
              }}
              onImageDelete={(index) => handleDeleteImages(index, "head")}
              reset={resetCaptureFlag}
              mandatoryFieldRef={mandatoryFieldRef}
            />
          </div>
        )}
        {isRequestForChange && (
          <div className="form-floating mb-1" style={approverCheckbox?.head ? {} : { display: "none" }}>
            {/* Approver comments shown only when the head field has been flagged for review */}
            <input
              type="text"
              disabled={!isAppprovalPending}
              ref={(el) =>
                (mandatoryFieldRef.current.headApproverComments = el)
              }
              className="form-control"
              id="floatingInputValue"
              name="head"
              value={approverComments?.head}
              onChange={(e) => {
                handleApproverComments(e);
              }}
            />
            <label htmlFor="floatingInputValue">
              Approver Comments for Head<span style={{ color: "red" }}>*</span>
            </label>
          </div>
        )}
      </div>}
      {isDoubleDoor && isRequestForChange && isApprover && (
        // For double doors, left and right head validations are handled separately.
        <div className="form-floating d-flex justify-content-end pb-2">
          <input
            className="form-check-input form-check-input-checkbox custom-checkbox"
            type="checkbox"
            id="leftHeadCheckbox"
            disabled={!isAppprovalPending}
            name="leftHead"
            checked={approverCheckbox?.leftHead || false}
            onChange={(e) => handleApproverCheckbox(e)}
          />
        </div>
      )}
      {isDoubleDoor && <div className="form-floating mb-3">
        <input
          type="number"
          pattern="[0-9]*"
          inputMode="decimal"
          onKeyDown={(e) => {
            if (e.key === "-" || e.key === "e") {
              e.preventDefault(); // Prevent invalid characters
            }
          }}
          disabled={isApprover ? isView : (isView && !approverCheckbox.leftHead)}
          className="form-control"
          id="floatingInputValue"
          placeholder="Left - Head(mm) "
          name="leftHead"
          ref={(el) => (mandatoryFieldRef.current.leftHead = el)}
          value={formData.leftHead}
          onChange={handleGapsChange}
          min={0}
        />
        <label htmlFor="floatingInputValue">
          Left - Head(mm)<span style={{ color: "red" }}>*</span>
        </label>
        {actionmenuFlag.leftHead && (
          <div className="col-sm-12 mb-3 border p-2 rounded">
            <MiniCapture
              isView={isApprover ? isView : (isView && !approverCheckbox.leftHead)}
              fieldValue={"leftHead"}
              savedImages={actionImages.leftHead}
              formData={formData}
              onImagesChange={(images, nameOfFile) =>
                handleImagesChangeMini(images, "leftHead", nameOfFile)
              }
              onResetChange={() => handleResetAction("leftHead", "PHYSICAL")}
              onHandleActionFieldsChange={(e, field) => {
                handleActionFieldsChange(e, field, "PHYSICAL");
              }}
              onImageDelete={(index) => handleDeleteImages(index, "leftHead")}
              reset={resetCaptureFlag}
              mandatoryFieldRef={mandatoryFieldRef}
            />
          </div>
        )}
        {isRequestForChange && (
          <div className="form-floating mb-1" style={approverCheckbox?.leftHead ? {} : { display: "none" }}>
            <input
              type="text"
              disabled={!isAppprovalPending}
              ref={(el) =>
                (mandatoryFieldRef.current.leftHeadApproverComments = el)
              }
              className="form-control"
              id="floatingInputValue"
              name="leftHead"
              value={approverComments?.leftHead}
              onChange={(e) => {
                handleApproverComments(e);
              }}
            />
            <label htmlFor="floatingInputValue">
              Approver Comments for Left - Head<span style={{ color: "red" }}>*</span>
            </label>
          </div>
        )}
      </div>}
      {isDoubleDoor && isRequestForChange && isApprover && (
        <div className="form-floating d-flex justify-content-end pb-2">
          <input
            className="form-check-input form-check-input-checkbox custom-checkbox"
            type="checkbox"
            id="rightHeadCheckbox"
            disabled={!isAppprovalPending}
            name="rightHead"
            checked={approverCheckbox?.rightHead || false}
            onChange={(e) => handleApproverCheckbox(e)}
          />
        </div>
      )}
      {isDoubleDoor && <div className="form-floating mb-3">
        <input
          type="number"
          pattern="[0-9]*"
          inputMode="decimal"
          onKeyDown={(e) => {
            if (e.key === "-" || e.key === "e") {
              e.preventDefault(); // Prevent invalid characters
            }
          }}
          disabled={isApprover ? isView : (isView && !approverCheckbox.rightHead)}
          className="form-control"
          id="floatingInputValue"
          placeholder="Right - Head(mm) "
          name="rightHead"
          ref={(el) => (mandatoryFieldRef.current.rightHead = el)}
          value={formData.rightHead}
          onChange={handleGapsChange}
          min={0}
        />
        <label htmlFor="floatingInputValue">
          Right - Head(mm)<span style={{ color: "red" }}>*</span>
        </label>
        {actionmenuFlag.rightHead && (
          <div className="col-sm-12 mb-3 border p-2 rounded">
            <MiniCapture
              isView={isApprover ? isView : (isView && !approverCheckbox.rightHead)}
              fieldValue={"rightHead"}
              savedImages={actionImages.rightHead}
              formData={formData}
              onImagesChange={(images, nameOfFile) =>
                handleImagesChangeMini(images, "rightHead", nameOfFile)
              }
              onResetChange={() => handleResetAction("rightHead", "PHYSICAL")}
              onHandleActionFieldsChange={(e, field) => {
                handleActionFieldsChange(e, field, "PHYSICAL");
              }}
              onImageDelete={(index) => handleDeleteImages(index, "rightHead")}
              reset={resetCaptureFlag}
              mandatoryFieldRef={mandatoryFieldRef}
            />
          </div>
        )}
        {isRequestForChange && (
          <div className="form-floating mb-1" style={approverCheckbox?.rightHead ? {} : { display: "none" }}>
            <input
              type="text"
              disabled={!isAppprovalPending}
              ref={(el) =>
                (mandatoryFieldRef.current.rightHeadApproverComments = el)
              }
              className="form-control"
              id="floatingInputValue"
              name="rightHead"
              value={approverComments?.rightHead}
              onChange={(e) => {
                handleApproverComments(e);
              }}
            />
            <label htmlFor="floatingInputValue">
              Approver Comments for Right - Head<span style={{ color: "red" }}>*</span>
            </label>
          </div>
        )}
      </div>}
      {isRequestForChange && isApprover && (
        <div className="form-floating d-flex justify-content-end pb-2">
          <input
            className="form-check-input form-check-input-checkbox custom-checkbox"
            type="checkbox"
            disabled={!isAppprovalPending}
            id="hingeLocationCheckbox"
            name="hingeLocation"
            checked={approverCheckbox?.hingeLocation || false}
            onChange={(e) => handleApproverCheckbox(e)}
          />
        </div>
      )}
      <div className="form-floating mb-3">
        <select
          className="form-select"
          name="hingeLocation"
          ref={(el) => (mandatoryFieldRef.current.hingeLocation = el)}
          disabled={isApprover ? isView : (isView && !approverCheckbox.hingeLocation)}
          id="floatingSelectHingeLocation"
          aria-label="Floating label select example"
          value={formData.hingeLocation}
          onChange={handleFormDataChange}
        >
          <option value="">Select</option>
          <option value="1">Left</option>
          <option value="2">Right</option>
        </select>
        <label htmlFor="floatingSelectHingeLocation">
          Hinge Location<span style={{ color: "red" }}>*</span>
        </label>
        {isRequestForChange && (
          <div className="form-floating mb-1" style={approverCheckbox?.hingeLocation ? {} : { display: "none" }}>
            <input
              type="text"
              ref={(el) =>
                (mandatoryFieldRef.current.hingeLocationApproverComments = el)
              }
              className="form-control"
              disabled={!isAppprovalPending}
              id="floatingInputValue"
              name="hingeLocation"
              value={approverComments?.hingeLocation}
              onChange={(e) => {
                handleApproverComments(e);
              }}
            />
            <label htmlFor="floatingInputValue">
              Approver Comments for Hinge Location<span style={{ color: "red" }}>*</span>
            </label>
          </div>
        )}
      </div>
      {isRequestForChange && isApprover && (
        <div className="form-floating d-flex justify-content-end pb-2">
          <input
            className="form-check-input form-check-input-checkbox custom-checkbox"
            type="checkbox"
            id="noOfHingesCheckbox"
            disabled={!isAppprovalPending}
            name="noOfHinges"
            checked={approverCheckbox?.noOfHinges || false}
            onChange={(e) => handleApproverCheckbox(e)}
          />
        </div>
      )}
      <div className="form-floating mb-3">
        <input
          type="number"
          pattern="[0-9]*"
          inputMode="integer"
          onKeyDown={(e) => {
            if (e.key === "-" || e.key === "e" || e.key === ".") {
              e.preventDefault(); // Prevent invalid characters
            }
          }}
          disabled={isApprover ? isView : (isView && !approverCheckbox.noOfHinges)}
          className="form-control"
          id="floatingInputValue"
          placeholder="Number of Hinges"
          value={formData.noOfHinges}
          name="noOfHinges"
          ref={(el) => (mandatoryFieldRef.current.noOfHinges = el)}
          onChange={handleGapsChange}
          min={0}
        />
        <label htmlFor="floatingInputValue">
          Number of Hinges<span style={{ color: "red" }}>*</span>
        </label>

        {actionmenuFlag.noOfHinges && (
          <div className="col-sm-12 mb-3 border p-2 rounded">
            <MiniCapture
              isView={isApprover ? isView : (isView && !approverCheckbox.noOfHinges)}
              mandatoryFieldRef={mandatoryFieldRef}
              fieldValue={"noOfHinges"}
              savedImages={actionImages.noOfHinges}
              formData={formData}
              onImagesChange={(images, nameOfFile) =>
                handleImagesChangeMini(images, "noOfHinges", nameOfFile)
              }
              onResetChange={() => handleResetAction("noOfHinges", "PHYSICAL")}
              onHandleActionFieldsChange={(e, field) => {
                handleActionFieldsChange(e, field, "PHYSICAL");
              }}
              onImageDelete={(index) => handleDeleteImages(index, "noOfHinges")}
              reset={resetCaptureFlag}
            />
          </div>
        )}
        {isRequestForChange && (
          <div className="form-floating mb-1" style={approverCheckbox?.noOfHinges ? {} : { display: "none" }}>
            <input
              type="text"
              ref={(el) =>
                (mandatoryFieldRef.current.noOfHingesApproverComments = el)
              }
              className="form-control"
              id="floatingInputValue"
              name="noOfHinges"
              disabled={!isAppprovalPending}
              value={approverComments?.noOfHinges}
              onChange={(e) => {
                handleApproverComments(e);
              }}
            />
            <label htmlFor="floatingInputValue">
              Approver Comments for No. of Hinges<span style={{ color: "red" }}>*</span>
            </label>
          </div>
        )}
      </div>
      {!isDoubleDoor && isRequestForChange && isApprover && (
        <div className="form-floating d-flex justify-content-end pb-2">
          <input
            className="form-check-input form-check-input-checkbox custom-checkbox"
            type="checkbox"
            id="hingeCheckbox"
            disabled={!isAppprovalPending}
            name="hinge"
            checked={approverCheckbox?.hinge || false}
            onChange={(e) => handleApproverCheckbox(e)}
          />
        </div>
      )}
      {!isDoubleDoor && <div className="form-floating mb-3">
        <input
          type="number"
          pattern="[0-9]*"
          inputMode="decimal"
          onKeyDown={(e) => {
            if (e.key === "-" || e.key === "e") {
              e.preventDefault(); // Prevent invalid characters
            }
          }}
          disabled={isApprover ? isView : (isView && !approverCheckbox.hinge)}
          className="form-control"
          id="floatingInputValue"
          placeholder="Hinge(mm)"
          value={formData.hinge}
          name="hinge"
          ref={(el) => (mandatoryFieldRef.current.hinge = el)}
          onChange={handleGapsChange}
          min={0}
        />
        <label htmlFor="floatingInputValue">
          Hinge(mm)<span style={{ color: "red" }}>*</span>
        </label>

        {actionmenuFlag.hinge && (
          <div className="col-sm-12 mb-3 border p-2 rounded">
            <MiniCapture
              isView={isApprover ? isView : (isView && !approverCheckbox.hinge)}
              mandatoryFieldRef={mandatoryFieldRef}
              fieldValue={"hinge"}
              savedImages={actionImages.hinge}
              formData={formData}
              onImagesChange={(images, nameOfFile) =>
                handleImagesChangeMini(images, "hinge", nameOfFile)
              }
              onResetChange={() => handleResetAction("hinge", "PHYSICAL")}
              onHandleActionFieldsChange={(e, field) => {
                handleActionFieldsChange(e, field, "PHYSICAL");
              }}
              onImageDelete={(index) => handleDeleteImages(index, "hinge")}
              reset={resetCaptureFlag}
            />
          </div>
        )}
        {isRequestForChange && (
          <div className="form-floating mb-1" style={approverCheckbox?.hinge ? {} : { display: "none" }}>
            <input
              type="text"
              ref={(el) =>
                (mandatoryFieldRef.current.hingeApproverComments = el)
              }
              className="form-control"
              id="floatingInputValue"
              name="hinge"
              disabled={!isAppprovalPending}
              value={approverComments?.hinge}
              onChange={(e) => {
                handleApproverComments(e);
              }}
            />
            <label htmlFor="floatingInputValue">
              Approver Comments for Hinge<span style={{ color: "red" }}>*</span>
            </label>
          </div>
        )}
      </div>}
      {isDoubleDoor && isRequestForChange && isApprover && (
        <div className="form-floating d-flex justify-content-end pb-2">
          <input
            className="form-check-input form-check-input-checkbox custom-checkbox"
            type="checkbox"
            id="leftHingeCheckbox"
            disabled={!isAppprovalPending}
            name="leftHinge"
            checked={approverCheckbox?.leftHinge || false}
            onChange={(e) => handleApproverCheckbox(e)}
          />
        </div>
      )}
      {isDoubleDoor && <div className="form-floating mb-3">
        <input
          type="number"
          pattern="[0-9]*"
          inputMode="decimal"
          onKeyDown={(e) => {
            if (e.key === "-" || e.key === "e") {
              e.preventDefault(); // Prevent invalid characters
            }
          }}
          disabled={isApprover ? isView : (isView && !approverCheckbox.leftHinge)}
          className="form-control"
          id="floatingInputValue"
          placeholder="Left - Hinge(mm)"
          value={formData.leftHinge}
          name="leftHinge"
          ref={(el) => (mandatoryFieldRef.current.leftHinge = el)}
          onChange={handleGapsChange}
          min={0}
        />
        <label htmlFor="floatingInputValue">
          Left - Hinge(mm)<span style={{ color: "red" }}>*</span>
        </label>

        {actionmenuFlag.leftHinge && (
          <div className="col-sm-12 mb-3 border p-2 rounded">
            <MiniCapture
              isView={isApprover ? isView : (isView && !approverCheckbox.leftHinge)}
              mandatoryFieldRef={mandatoryFieldRef}
              fieldValue={"leftHinge"}
              savedImages={actionImages.leftHinge}
              formData={formData}
              onImagesChange={(images, nameOfFile) =>
                handleImagesChangeMini(images, "leftHinge", nameOfFile)
              }
              onResetChange={() => handleResetAction("leftHinge", "PHYSICAL")}
              onHandleActionFieldsChange={(e, field) => {
                handleActionFieldsChange(e, field, "PHYSICAL");
              }}
              onImageDelete={(index) => handleDeleteImages(index, "leftHinge")}
              reset={resetCaptureFlag}
            />
          </div>
        )}
        {isRequestForChange && (
          <div className="form-floating mb-1" style={approverCheckbox?.leftHinge ? {} : { display: "none" }}>
            <input
              type="text"
              ref={(el) =>
                (mandatoryFieldRef.current.leftHingeApproverComments = el)
              }
              className="form-control"
              id="floatingInputValue"
              name="leftHinge"
              disabled={!isAppprovalPending}
              value={approverComments?.leftHinge}
              onChange={(e) => {
                handleApproverComments(e);
              }}
            />
            <label htmlFor="floatingInputValue">
              Approver Comments for Left - Hinge<span style={{ color: "red" }}>*</span>
            </label>
          </div>
        )}
      </div>}
      {isDoubleDoor && isRequestForChange && isApprover && (
        <div className="form-floating d-flex justify-content-end pb-2">
          <input
            className="form-check-input form-check-input-checkbox custom-checkbox"
            type="checkbox"
            id="rightHingeCheckbox"
            disabled={!isAppprovalPending}
            name="rightHinge"
            checked={approverCheckbox?.rightHinge || false}
            onChange={(e) => handleApproverCheckbox(e)}
          />
        </div>
      )}
      {isDoubleDoor && <div className="form-floating mb-3">
        <input
          type="number"
          pattern="[0-9]*"
          inputMode="decimal"
          onKeyDown={(e) => {
            if (e.key === "-" || e.key === "e") {
              e.preventDefault(); // Prevent invalid characters
            }
          }}
          disabled={isApprover ? isView : (isView && !approverCheckbox.rightHinge)}
          className="form-control"
          id="floatingInputValue"
          placeholder="Right - Hinge(mm)"
          value={formData.rightHinge}
          name="rightHinge"
          ref={(el) => (mandatoryFieldRef.current.rightHinge = el)}
          onChange={handleGapsChange}
          min={0}
        />
        <label htmlFor="floatingInputValue">
          Right - Hinge(mm)<span style={{ color: "red" }}>*</span>
        </label>

        {actionmenuFlag.rightHinge && (
          <div className="col-sm-12 mb-3 border p-2 rounded">
            <MiniCapture
              isView={isApprover ? isView : (isView && !approverCheckbox.rightHinge)}
              mandatoryFieldRef={mandatoryFieldRef}
              fieldValue={"rightHinge"}
              savedImages={actionImages.rightHinge}
              formData={formData}
              onImagesChange={(images, nameOfFile) =>
                handleImagesChangeMini(images, "rightHinge", nameOfFile)
              }
              onResetChange={() => handleResetAction("rightHinge", "PHYSICAL")}
              onHandleActionFieldsChange={(e, field) => {
                handleActionFieldsChange(e, field, "PHYSICAL");
              }}
              onImageDelete={(index) => handleDeleteImages(index, "rightHinge")}
              reset={resetCaptureFlag}
            />
          </div>
        )}
        {isRequestForChange && (
          <div className="form-floating mb-1" style={approverCheckbox?.rightHinge ? {} : { display: "none" }}>
            <input
              type="text"
              ref={(el) =>
                (mandatoryFieldRef.current.rightHingeApproverComments = el)
              }
              className="form-control"
              id="floatingInputValue"
              name="rightHinge"
              disabled={!isAppprovalPending}
              value={approverComments?.rightHinge}
              onChange={(e) => {
                handleApproverComments(e);
              }}
            />
            <label htmlFor="floatingInputValue">
              Approver Comments for Right - Hinge<span style={{ color: "red" }}>*</span>
            </label>
          </div>
        )}
      </div>}
      {isRequestForChange && isApprover && (
        <div className="form-floating d-flex justify-content-end pb-2">
          <input
            className="form-check-input form-check-input-checkbox custom-checkbox"
            type="checkbox"
            id="closingCheckbox"
            disabled={!isAppprovalPending}
            name="closing"
            checked={approverCheckbox?.closing || false}
            onChange={(e) => handleApproverCheckbox(e)}
          />
        </div>
      )}
      <div className="form-floating mb-3">
        <input
          type="number"
          pattern="[0-9]*"
          inputMode="decimal"
          onKeyDown={(e) => {
            if (e.key === "-" || e.key === "e") {
              e.preventDefault(); // Prevent invalid characters
            }
          }}
          className="form-control"
          id="floatingInputValue"
          placeholder="Closing(mm) "
          value={formData.closing}
          disabled={isApprover ? isView : (isView && !approverCheckbox.closing)}
          name="closing"
          ref={(el) => (mandatoryFieldRef.current.closing = el)}
          onChange={handleGapsChange}
          min={0}
        />
        <label htmlFor="floatingInputValue">
          Closing(mm)<span style={{ color: "red" }}>*</span>
        </label>
        {actionmenuFlag.closing && (
          <div className="col-sm-12 mb-3 border p-2 rounded">
            <MiniCapture
              isView={isApprover ? isView : (isView && !approverCheckbox.closing)}
              mandatoryFieldRef={mandatoryFieldRef}
              fieldValue={"closing"}
              savedImages={actionImages.closing}
              formData={formData}
              onImagesChange={(images, nameOfFile) =>
                handleImagesChangeMini(images, "closing", nameOfFile)
              }
              onResetChange={() => handleResetAction("closing", "PHYSICAL")}
              onHandleActionFieldsChange={(e, field) => {
                handleActionFieldsChange(e, field, "PHYSICAL");
              }}
              onImageDelete={(index) => handleDeleteImages(index, "closing")}
              reset={resetCaptureFlag}
            />
          </div>
        )}
        {isRequestForChange && (
          <div className="form-floating mb-1" style={approverCheckbox?.closing ? {} : { display: "none" }}>
            <input
              type="text"
              ref={(el) =>
                (mandatoryFieldRef.current.closingApproverComments = el)
              }
              className="form-control"
              id="floatingInputValue"
              name="closing"
              disabled={!isAppprovalPending}
              value={approverComments?.closing}
              onChange={(e) => {
                handleApproverComments(e);
              }}
            />
            <label htmlFor="floatingInputValue">
              Approver Comments for Closing<span style={{ color: "red" }}>*</span>
            </label>
          </div>
        )}
      </div>

      {!isDoubleDoor && isRequestForChange && isApprover && (
        <div className="form-floating d-flex justify-content-end pb-2">
          <input
            className="form-check-input form-check-input-checkbox custom-checkbox"
            type="checkbox"
            id="thresholdCheckbox"
            disabled={!isAppprovalPending}
            name="threshold"
            checked={approverCheckbox?.threshold || false}
            onChange={(e) => handleApproverCheckbox(e)}
          />
        </div>
      )}
      {!isDoubleDoor && <div className="form-floating mb-3">
        <input
          type="number"
          pattern="[0-9]*"
          inputMode="decimal"
          onKeyDown={(e) => {
            if (e.key === "-" || e.key === "e") {
              e.preventDefault(); // Prevent invalid characters
            }
          }}
          className="form-control"
          id="floatingInputValue"
          disabled={isApprover ? isView : (isView && !approverCheckbox.threshold)}
          placeholder="Threshold(mm) "
          ref={(el) => (mandatoryFieldRef.current.threshold = el)}
          name="threshold"
          value={formData.threshold}
          onChange={handleGapsChange}
          min={0}
        />
        <label htmlFor="floatingInputValue">
          Threshold(mm)<span style={{ color: "red" }}>*</span>
        </label>
        {actionmenuFlag.threshold && (
          <div className="col-sm-12 mb-3 border p-2 rounded">
            <MiniCapture
              isView={isApprover ? isView : (isView && !approverCheckbox.threshold)}
              mandatoryFieldRef={mandatoryFieldRef}
              fieldValue={"threshold"}
              savedImages={actionImages.threshold}
              formData={formData}
              onImagesChange={(images, nameOfFile) =>
                handleImagesChangeMini(images, "threshold", nameOfFile)
              }
              onResetChange={() => handleResetAction("threshold", "PHYSICAL")}
              onHandleActionFieldsChange={(e, field) => {
                handleActionFieldsChange(e, field, "PHYSICAL");
              }}
              onImageDelete={(index) => handleDeleteImages(index, "threshold")}
              reset={resetCaptureFlag}
            />
          </div>
        )}
        {isRequestForChange && (
          <div className="form-floating mb-1" style={approverCheckbox?.threshold ? {} : { display: "none" }}>
            <input
              type="text"
              ref={(el) =>
                (mandatoryFieldRef.current.thresholdApproverComments = el)
              }
              className="form-control"
              id="floatingInputValue"
              name="threshold"
              disabled={!isAppprovalPending}
              value={approverComments?.threshold}
              onChange={(e) => {
                handleApproverComments(e);
              }}
            />
            <label htmlFor="floatingInputValue">
              Approver Comments for Threshold<span style={{ color: "red" }}>*</span>
            </label>
          </div>
        )}
      </div>}
      {isDoubleDoor && isRequestForChange && isApprover && (
        <div className="form-floating d-flex justify-content-end pb-2">
          <input
            className="form-check-input form-check-input-checkbox custom-checkbox"
            type="checkbox"
            id="leftThresholdCheckbox"
            disabled={!isAppprovalPending}
            name="leftThreshold"
            checked={approverCheckbox?.leftThreshold || false}
            onChange={(e) => handleApproverCheckbox(e)}
          />
        </div>
      )}
      {isDoubleDoor && <div className="form-floating mb-3">
        <input
          type="number"
          pattern="[0-9]*"
          inputMode="decimal"
          onKeyDown={(e) => {
            if (e.key === "-" || e.key === "e") {
              e.preventDefault(); // Prevent invalid characters
            }
          }}
          className="form-control"
          id="floatingInputValue"
          disabled={isApprover ? isView : (isView && !approverCheckbox.leftThreshold)}
          placeholder="Left - Threshold(mm) "
          ref={(el) => (mandatoryFieldRef.current.leftThreshold = el)}
          name="leftThreshold"
          value={formData.leftThreshold}
          onChange={handleGapsChange}
          min={0}
        />
        <label htmlFor="floatingInputValue">
          Left - Threshold(mm)<span style={{ color: "red" }}>*</span>
        </label>
        {actionmenuFlag.leftThreshold && (
          <div className="col-sm-12 mb-3 border p-2 rounded">
            <MiniCapture
              isView={isApprover ? isView : (isView && !approverCheckbox.leftThreshold)}
              mandatoryFieldRef={mandatoryFieldRef}
              fieldValue={"leftThreshold"}
              savedImages={actionImages.leftThreshold}
              formData={formData}
              onImagesChange={(images, nameOfFile) =>
                handleImagesChangeMini(images, "leftThreshold", nameOfFile)
              }
              onResetChange={() => handleResetAction("leftThreshold", "PHYSICAL")}
              onHandleActionFieldsChange={(e, field) => {
                handleActionFieldsChange(e, field, "PHYSICAL");
              }}
              onImageDelete={(index) => handleDeleteImages(index, "leftThreshold")}
              reset={resetCaptureFlag}
            />
          </div>
        )}
        {isRequestForChange && (
          <div className="form-floating mb-1" style={approverCheckbox?.leftThreshold ? {} : { display: "none" }}>
            <input
              type="text"
              ref={(el) =>
                (mandatoryFieldRef.current.leftThresholdApproverComments = el)
              }
              className="form-control"
              id="floatingInputValue"
              name="leftThreshold"
              disabled={!isAppprovalPending}
              value={approverComments?.leftThreshold}
              onChange={(e) => {
                handleApproverComments(e);
              }}
            />
            <label htmlFor="floatingInputValue">
              Approver Comments for Left - Threshold<span style={{ color: "red" }}>*</span>
            </label>
          </div>
        )}
      </div>}
      {isDoubleDoor && isRequestForChange && isApprover && (
        <div className="form-floating d-flex justify-content-end pb-2">
          <input
            className="form-check-input form-check-input-checkbox custom-checkbox"
            type="checkbox"
            id="rightThresholdCheckbox"
            disabled={!isAppprovalPending}
            name="rightThreshold"
            checked={approverCheckbox?.rightThreshold || false}
            onChange={(e) => handleApproverCheckbox(e)}
          />
        </div>
      )}
      {isDoubleDoor && <div className="form-floating mb-3">
        <input
          type="number"
          pattern="[0-9]*"
          inputMode="decimal"
          onKeyDown={(e) => {
            if (e.key === "-" || e.key === "e") {
              e.preventDefault(); // Prevent invalid characters
            }
          }}
          className="form-control"
          id="floatingInputValue"
          disabled={isApprover ? isView : (isView && !approverCheckbox.rightThreshold)}
          placeholder="Right - Threshold(mm) "
          ref={(el) => (mandatoryFieldRef.current.rightThreshold = el)}
          name="rightThreshold"
          value={formData.rightThreshold}
          onChange={handleGapsChange}
          min={0}
        />
        <label htmlFor="floatingInputValue">
          Right - Threshold(mm)<span style={{ color: "red" }}>*</span>
        </label>
        {actionmenuFlag.rightThreshold && (
          <div className="col-sm-12 mb-3 border p-2 rounded">
            <MiniCapture
              isView={isApprover ? isView : (isView && !approverCheckbox.rightThreshold)}
              mandatoryFieldRef={mandatoryFieldRef}
              fieldValue={"rightThreshold"}
              savedImages={actionImages.rightThreshold}
              formData={formData}
              onImagesChange={(images, nameOfFile) =>
                handleImagesChangeMini(images, "rightThreshold", nameOfFile)
              }
              onResetChange={() => handleResetAction("rightThreshold", "PHYSICAL")}
              onHandleActionFieldsChange={(e, field) => {
                handleActionFieldsChange(e, field, "PHYSICAL");
              }}
              onImageDelete={(index) => handleDeleteImages(index, "rightThreshold")}
              reset={resetCaptureFlag}
            />
          </div>
        )}
        {isRequestForChange && (
          <div className="form-floating mb-1" style={approverCheckbox?.rightThreshold ? {} : { display: "none" }}>
            <input
              type="text"
              ref={(el) =>
                (mandatoryFieldRef.current.rightThresholdApproverComments = el)
              }
              className="form-control"
              id="floatingInputValue"
              name="rightThreshold"
              disabled={!isAppprovalPending}
              value={approverComments?.rightThreshold}
              onChange={(e) => {
                handleApproverComments(e);
              }}
            />
            <label htmlFor="floatingInputValue">
              Approver Comments for Right - Threshold<span style={{ color: "red" }}>*</span>
            </label>
          </div>
        )}
      </div>}

      {isRequestForChange && isApprover && (
        <div className="form-floating d-flex justify-content-end pb-2">
          <input
            className="form-check-input form-check-input-checkbox custom-checkbox"
            type="checkbox"
            id="doorThicknessCheckbox"
            disabled={!isAppprovalPending}
            name="doorThickness"
            checked={approverCheckbox?.doorThickness || false}
            onChange={(e) => handleApproverCheckbox(e)}
          />
        </div>
      )}
      <div className="form-floating mb-3">
        <input
          type="number"
          pattern="[0-9]*"
          inputMode="decimal"
          onKeyDown={(e) => {
            if (e.key === "-" || e.key === "e") {
              e.preventDefault(); // Prevent invalid characters
            }
          }}
          className="form-control"
          id="floatingInputValue"
          disabled={isApprover ? isView : (isView && !approverCheckbox.doorThickness)}
          placeholder="Door Thickness(mm)"
          name="doorThickness"
          ref={(el) => (mandatoryFieldRef.current.doorThickness = el)}
          value={formData.doorThickness}
          onChange={handleFormDataChange}
          min={0}
        />
        <label htmlFor="floatingInputValue">
          Door Thickness(mm)
          <span style={{ color: "red" }}>*</span>
        </label>
        {isRequestForChange && (
          <div className="form-floating mb-1" style={approverCheckbox?.doorThickness ? {} : { display: "none" }}>
            <input
              type="text"
              ref={(el) =>
                (mandatoryFieldRef.current.doorThicknessApproverComments = el)
              }
              className="form-control"
              id="floatingInputValue"
              name="doorThickness"
              disabled={!isAppprovalPending}
              value={approverComments?.doorThickness}
              onChange={(e) => {
                handleApproverComments(e);
              }}
            />
            <label htmlFor="floatingInputValue">
              Approver Comments for Door Thickness<span style={{ color: "red" }}>*</span>
            </label>
          </div>
        )}
      </div>

      {isRequestForChange && isApprover && (
        <div className="form-floating d-flex justify-content-end pb-2">
          <input
            className="form-check-input form-check-input-checkbox custom-checkbox"
            type="checkbox"
            id="frameDepthCheckbox"
            disabled={!isAppprovalPending}
            name="frameDepth"
            checked={approverCheckbox?.frameDepth || false}
            onChange={(e) => handleApproverCheckbox(e)}
          />
        </div>
      )}
      <div className="form-floating mb-3">
        <input
          type="number"
          pattern="[0-9]*"
          inputMode="decimal"
          onKeyDown={(e) => {
            if (e.key === "-" || e.key === "e") {
              e.preventDefault(); // Prevent invalid characters
            }
          }}
          className="form-control"
          id="floatingInputValue"
          placeholder="Frame Depth(mm)"
          name="frameDepth"
          disabled={isApprover ? isView : (isView && !approverCheckbox.frameDepth)}
          ref={(el) => (mandatoryFieldRef.current.frameDepth = el)}
          value={formData.frameDepth}
          onChange={handleFormDataChange}
          min={0}
        />
        <label htmlFor="floatingInputValue">
          Frame Depth(mm)<span style={{ color: "red" }}>*</span>
        </label>
        {isRequestForChange &&  (
          <div className="form-floating mb-1" style={approverCheckbox?.frameDepth ? {} : { display: "none" }}>
            <input
              type="text"
              ref={(el) =>
                (mandatoryFieldRef.current.frameDepthApproverComments = el)
              }
              className="form-control"
              id="floatingInputValue"
              disabled={!isAppprovalPending}
              name="frameDepth"
              value={approverComments?.frameDepth}
              onChange={(e) => {
                handleApproverComments(e);
              }}
            />
            <label htmlFor="floatingInputValue">
              Approver Comments for Frame Depth<span style={{ color: "red" }}>*</span>
            </label>
          </div>
        )}
      </div>

      {isRequestForChange && isApprover && (
        <div className="form-floating d-flex justify-content-end pb-2">
          <input
            className="form-check-input form-check-input-checkbox custom-checkbox"
            type="checkbox"
            id="doorHeightCheckbox"
            disabled={!isAppprovalPending}
            name="doorHeight"
            checked={approverCheckbox?.doorHeight || false}
            onChange={(e) => handleApproverCheckbox(e)}
          />
        </div>
      )}
      <div className="form-floating mb-3">
        <input
          type="number"
          pattern="[0-9]*"
          inputMode="decimal"
          onKeyDown={(e) => {
            if (e.key === "-" || e.key === "e") {
              e.preventDefault(); // Prevent invalid characters
            }
          }}
          className="form-control"
          id="floatingInputValue"
          placeholder="Door Height(mm)"
          name="doorHeight"
          disabled={isApprover ? isView : (isView && !approverCheckbox.doorHeight)}
          value={formData.doorHeight}
          ref={(el) => (mandatoryFieldRef.current.doorHeight = el)}
          onChange={handleFormDataChange}
          min={0}
        />
        <label htmlFor="floatingInputValue">
          Door Size - Height(mm)<span style={{ color: "red" }}>*</span>
        </label>
        {isRequestForChange && (
          <div className="form-floating mb-1" style={approverCheckbox?.doorHeight ? {} : { display: "none" }}>
            <input
              type="text"
              ref={(el) =>
                (mandatoryFieldRef.current.doorHeightApproverComments = el)
              }
              className="form-control"
              id="floatingInputValue"
              name="doorHeight"
              disabled={!isAppprovalPending}
              value={approverComments?.doorHeight}
              onChange={(e) => {
                handleApproverComments(e);
              }}
            />
            <label htmlFor="floatingInputValue">
              Approver Comments for Door Height<span style={{ color: "red" }}>*</span>
            </label>
          </div>
        )}
      </div>

      {isRequestForChange && isApprover && (
        <div className="form-floating d-flex justify-content-end pb-2">
          <input
            className="form-check-input form-check-input-checkbox custom-checkbox"
            type="checkbox"
            id="doorWidthCheckbox"
            disabled={!isAppprovalPending}
            name="doorWidth"
            checked={approverCheckbox?.doorWidth || false}
            onChange={(e) => handleApproverCheckbox(e)}
          />
        </div>
      )}
      <div className="form-floating mb-3">
        <input
          type="number"
          pattern="[0-9]*"
          inputMode="decimal"
          onKeyDown={(e) => {
            if (e.key === "-" || e.key === "e") {
              e.preventDefault(); // Prevent invalid characters
            }
          }}
          className="form-control"
          id="floatingInputValue"
          placeholder="Door Width(mm)"
          name="doorWidth"
          disabled={isApprover ? isView : (isView && !approverCheckbox.doorWidth)}
          value={formData.doorWidth}
          ref={(el) => (mandatoryFieldRef.current.doorWidth = el)}
          onChange={handleFormDataChange}
          min={0}
        />
        <label htmlFor="floatingInputValue">
          Door Size - Width(mm)<span style={{ color: "red" }}>*</span>
        </label>
        {isRequestForChange && (
          <div className="form-floating mb-1" style={approverCheckbox?.doorWidth ? {} : { display: "none" }}>
            <input
              type="text"
              ref={(el) =>
                (mandatoryFieldRef.current.doorWidthApproverComments = el)
              }
              className="form-control"
              id="floatingInputValue"
              name="doorWidth"
              disabled={!isAppprovalPending}
              value={approverComments?.doorWidth}
              onChange={(e) => {
                handleApproverComments(e);
              }}
            />
            <label htmlFor="floatingInputValue">
              Approver Comments for Door Width<span style={{ color: "red" }}>*</span>
            </label>
          </div>
        )}
      </div>

      {isRequestForChange && isApprover && (
        <div className="form-floating d-flex justify-content-end pb-2">
          <input
            className="form-check-input form-check-input-checkbox custom-checkbox"
            type="checkbox"
            id="fullDoorsetSizeCheckbox"
            name="fullDoorsetSize"
            disabled={!isAppprovalPending}
            checked={approverCheckbox?.fullDoorsetSize || false}
            onChange={(e) => handleApproverCheckbox(e)}
          />
        </div>
      )}
      <div className="form-floating">
        <input
          type="number"
          pattern="[0-9]*"
          inputMode="decimal"
          onKeyDown={(e) => {
            if (e.key === "-" || e.key === "e") {
              e.preventDefault(); // Prevent invalid characters
            }
          }}
          className="form-control"
          id="floatingInputValue"
          placeholder="Full Doorset Size(mm)"
          name="fullDoorsetSize"
          disabled={isApprover ? isView : (isView && !approverCheckbox.fullDoorsetSize)}
          ref={(el) => (mandatoryFieldRef.current.fullDoorsetSize = el)}
          value={formData.fullDoorsetSize}
          onChange={handleFormDataChange}
          min={0}
        />
        <label htmlFor="floatingInputValue">
          Full Doorset Size(mm)
          <span style={{ color: "red" }}>*</span>
        </label>
        {isRequestForChange && (
          <div className="form-floating mb-1" style={approverCheckbox?.fullDoorsetSize ? {} : { display: "none" }}>
            <input
              type="text"
              ref={(el) =>
                (mandatoryFieldRef.current.fullDoorsetSizeApproverComments = el)
              }
              className="form-control"
              id="floatingInputValue"
              name="fullDoorsetSize"
              disabled={!isAppprovalPending}
              value={approverComments?.fullDoorsetSize}
              onChange={(e) => {
                handleApproverComments(e);
              }}
            />
            <label htmlFor="floatingInputValue">
              Approver Comments for Full Doorset Size<span style={{ color: "red" }}>*</span>
            </label>
          </div>
        )}
      </div>
    </div>
  );
};

export default PhyMeasurementsSection;
